import { Spinner } from 'reactstrap';

interface SuspenseFallbackProps {
  message?: string;
}

/** While a lazily loaded page arrives. */
export default function SuspenseFallback({ message = 'Cargando…' }: SuspenseFallbackProps) {
  return (
    <div className="v-loading" role="status">
      <Spinner />
      <span>{message}</span>
    </div>
  );
}
